import GTM from '../../gtm/GTM';
import GTMViewItemModel from '../../gtm/models/GTMViewItemModel';
import DetailFormTracking from './components/DetailFormTracking';

document.addEventListener('DOMContentLoaded', (): void => {
    const houseData = DetailFormTracking.getHouseDetailDataLayerData();
    const house = houseData?.products?.[0];

    if (!houseData || !house) {
        return;
    }

    GTM.track(
        GTMViewItemModel.parseToGTMData({
            id: houseData.products[0].id,
            title: houseData.products[0].name,
            country: houseData.custom_lastcountry,
            region: houseData.custom_lastregion,
            department: houseData.custom_lastdepartment,
            place: houseData.custom_lastcity,
            cancellationPolicy: houseData.cancellation_policy,
            quantity: 1
        })
    );
});
